import { Badge } from '../Badge'
import { Button } from '../Button'
import { Image } from '../Image'

export type NotificationCounterProps = {
  countUnreadNotifications: number
  handleMarkAllReadClick: () => void
}

export const NotificationCounter: React.FC<NotificationCounterProps> = ({
  countUnreadNotifications,
  handleMarkAllReadClick
}) => {
  return (
    <Button variant="transparent" onClick={handleMarkAllReadClick} overflow="visible !important">
      <Badge count={countUnreadNotifications} offset={[3, -3]}>
        <Image type="bell" alt="bell" />
      </Badge>
    </Button>
  )
}
